import React, { Component } from 'react'
import styles from './style.module.less'
import Loading from './loading'
// 统一结果展示页面
export default class ResultPage extends Component {
  render() {
    const { type, icon, title, subtitle, extra } = this.props
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          {type === 'loading' ? (
            <Loading {...this.props} />
          ) : (
            <img className={styles.img} src={icon} />
          )}
          <div className={styles.title}>{title}</div>
          <div className={styles.sub}>{subtitle}</div>
          {extra}
        </div>
      </div>
    )
  }
}
